/**
 * Disposable/temporary email domain blocklist
 * Used to prevent signup with temporary email services
 * 
 * This list includes popular temporary email services that are commonly used
 * to create throwaway accounts or abuse free trials.
 */

export const DISPOSABLE_EMAIL_DOMAINS = [
  // Popular temporary email services
  'temp-mail.org',
  'tempmail.com',
  'temp-mail.io',
  'tempmail.net',
  'temp-mail.net',
  '10minutemail.com',
  '10minutemail.net',
  'guerrillamail.com',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamail.biz',
  'guerrillamail.de',
  'sharklasers.com',
  'spam4.me',
  'grr.la',
  'guerrillamailblock.com',
  'mailinator.com',
  'mailinator.net',
  'mailinator.org',
  'mailinator2.com',
  'trashmail.com',
  'trashmail.net',
  'throwawaymаil.com',
  'throwawaymail.com',
  'throwam.com',
  'getnada.com',
  'maildrop.cc',
  'yopmail.com',
  'yopmail.fr',
  'yopmail.net',
  'cool.fr.nf',
  'jetable.fr.nf',
  'nospam.ze.tc',
  'nomail.xl.cx',
  'mega.zik.dj',
  'speed.1s.fr',
  'courriel.fr.nf',
  'moncourrier.fr.nf',
  'monemail.fr.nf',
  'monmail.fr.nf',
  'hide.biz.st',
  'mymail.infos.st',
  'fakeinbox.com',
  'fakeinbox.net',
  'emailondeck.com',
  'mintemail.com',
  'spamgourmet.com',
  'spamgourmet.net',
  'spamgourmet.org',
  'dispostable.com',
  'spambox.us',
  'spamfree24.org',
  'spamfree24.de',
  'spamfree24.com',
  'spamfree24.net',
  'spamfree24.eu',
  'getairmail.com',
  'getonemail.com',
  'trash-mail.com',
  'wegwerfmail.de',
  'wegwerfmail.net',
  'wegwerfmail.org',
  'mytrashmail.com',
  'drdrb.com',
  'mailcatch.com',
  'spamex.com',
  'spamavert.com',
  'filzmail.com',
  'spammotel.com',
  'spamspot.com',
  'spam.la',
  'tempr.email',
  'tempinbox.com',
  'throwawayemailaddress.com',
  'burnermail.io',
  'harakirimail.com',
  'anonbox.net',
  'anonymbox.com',
  'mailnesia.com',
  'mailin8r.com',
  'mailnull.com',
  'mailshell.com',
  'mailsac.com',
  'mailtemp.info',
  'mailforspam.com',
  'mailme.ir',
  'mailme.lv',
  'mailmetrash.com',
  'mailmoat.com',
  'airmail.cc',
  'amail4.me',
  'amiri.net',
  'amiriindustries.com',
  'cmail.net',
  'cmail.org',
  'cmail.com',
  'deadaddress.com',
  'deadfake.cf',
  'deadfake.ga',
  'deadfake.ml',
  'deadfake.tk',
  'delikkt.de',
  'discardmail.com',
  'discardmail.de',
  'disposableaddress.com',
  'disposableemailaddresses.com',
  'disposableinbox.com',
  'dispose.it',
  'dodgeit.com',
  'dodgit.com',
  'dodgit.org',
  'donemail.ru',
  'dontreg.com',
  'dump-email.info',
  'dumpmail.de',
  'e4ward.com',
  'email-fake.cf',
  'email-fake.ga',
  'email-fake.gq',
  'email-fake.ml',
  'email-fake.tk',
  'emailias.com',
  'emailigo.de',
  'emailinfive.com',
  'emailmiser.com',
  'emailsensei.com',
  'emailtemporar.ro',
  'emailtemporario.com.br',
  'emailthe.net',
  'emailtmp.com',
  'emailwarden.com',
  'emailx.at.hm',
  'emailxfer.com',
  'emeil.in',
  'emeil.ir',
  'emz.net',
  'evopo.com',
  'fastacura.com',
  'fastchevy.com',
  'fastchrysler.com',
  'fastkawasaki.com',
  'fastmazda.com',
  'fastmitsubishi.com',
  'fastnissan.com',
  'fastsubaru.com',
  'fastsuzuki.com',
  'fasttoyota.com',
  'fastyamaha.com',
  'fizmail.com',
  'fr33mail.info',
  'frapmail.com',
  'front14.org',
  'fux0ringduh.com',
  'garbagemail.org',
  'gawab.com',
  'get1mail.com',
  'get2mail.fr',
  'getairmail.cf',
  'getairmail.ga',
  'getairmail.gq',
  'getairmail.ml',
  'getairmail.tk',
  'getmails.eu',
  'h.mintemail.com',
  'haltospam.com',
  'hatespam.org',
  'hidemail.de',
  'ieatspam.eu',
  'ieatspam.info',
  'ihateyoualot.info',
  'iheartspam.org',
  'imails.info',
  'inboxclean.com',
  'inboxclean.org',
  'incognitomail.com',
  'incognitomail.net',
  'incognitomail.org',
  'insorg-mail.info',
  'instant-mail.de',
  'ipoo.org',
  'irish2me.com',
  'iwi.net',
  'jetable.com',
  'jetable.net',
  'jetable.org',
  'jetable.pp.ua',
  'jnxjn.com',
  'jourrapide.com',
  'jsrsolutions.com',
  'kasmail.com',
  'kaspop.com',
  'keepmymail.com',
  'killmail.com',
  'killmail.net',
  'kir.ch.tc',
  'klassmaster.com',
  'klassmaster.net',
  'klzlk.com',
  'koszmail.pl',
  'kurzepost.de',
  'lawlita.com',
  'letthemeatspam.com',
  'lhsdv.com',
  'lifebyfood.com',
  'link2mail.net',
  'litedrop.com',
  'lol.ovpn.to',
  'lookugly.com',
  'lopl.co.cc',
  'lortemail.dk',
  'lr78.com',
  'lroid.com',
  'lukop.dk',
  'm4ilweb.info',
  'maboard.com',
  'mail-easy.fr',
  'mail-filter.com',
  'mail-temporaire.fr',
  'mail.by',
  'mail.mezimages.net',
  'mail2rss.org',
  'mail333.com',
  'mail4trash.com',
  'mailbidon.com',
  'mailblocks.com',
  'mailbucket.org',
  'mailcat.biz',
  'mailcatch.com',
  'mailde.de',
  'mailde.info',
  'maildx.com',
  'maileater.com',
  'mailed.ro',
  'mailexpire.com',
  'mailfall.com',
  'mailfree.ga',
  'mailfree.gq',
  'mailfree.ml',
  'mailfreeonline.com',
  'mailguard.me',
  'mailimate.com',
  'mailin8r.com',
  'mailinater.com',
  'mailinator.gq',
  'mailinator.us',
  'mailinator1.com',
  'mailinator2.com',
];

/**
 * Check if an email address uses a disposable/temporary email domain
 * @param email - The email address to check
 * @returns true if the email uses a disposable domain, false otherwise
 */
export function isDisposableEmail(email: string): boolean {
  if (!email || typeof email !== 'string') {
    return false;
  }

  // Extract domain from email (everything after @)
  const domain = email.toLowerCase().trim().split('@')[1];
  
  if (!domain) {
    return false;
  }

  // Check if domain is in the blocklist
  return DISPOSABLE_EMAIL_DOMAINS.includes(domain);
}

/**
 * Get a user-friendly error message for disposable email rejection
 */
export function getDisposableEmailErrorMessage(): string {
  return 'Temporary or disposable email addresses are not allowed. Please use a permanent email address to sign up.';
}
